module.exports = __webpack_public_path__ + "static/media/map.0d18f88e.jpg";